import { SYNC_TABLES } from './schema.js';
import { enqueueAll } from '../db/mutate.js';
import { getMeta, setMeta } from '../db/meta.js';
import { createLocalSnapshot } from '../backup/localSnapshots.js';

/**
 * Decide what to do with local data when a user signs in.
 * - 'same':     data already belongs to this account.
 * - 'linked':   guest data (no owner yet) is adopted and uploaded to the account.
 * - 'switched': data belonged to another account; it is snapshotted locally,
 *               then cleared so accounts never mix.
 */
export async function ensureOwner(db, userId) {
  const owner = await getMeta(db, 'ownerId');
  if (owner === userId) return 'same';
  if (!owner) {
    await enqueueAll(db);
    await setMeta(db, 'cursor', { tx: 0, seq: 0 });
    await setMeta(db, 'ownerId', userId);
    return 'linked';
  }
  await createLocalSnapshot(db, 'account-switch', { skipIfEmpty: true });
  await wipeLocalData(db);
  await setMeta(db, 'ownerId', userId);
  return 'switched';
}

/** Remove all replicated data from this device (keeps device id and clock). */
export async function wipeLocalData(db) {
  await db.transaction('rw', [...SYNC_TABLES.map((t) => db[t]), db.outbox, db.meta], async () => {
    for (const t of SYNC_TABLES) await db[t].clear();
    await db.outbox.clear();
    await db.meta.bulkDelete(['cursor', 'ownerId', 'settingsJoin', 'lastCloudBackupDay', 'lastCloudBackupAt']);
  });
}
